import { FC } from 'react';
import { FormControl, FormLabel } from 'react-bootstrap';
import FormGroup from 'components/FormGroup';
import Checkbox from 'components/forms/Checkbox';
import { SameDeliveryAndResidence } from 'components/forms/DeliveryAddress';
import { BaseHomeAddressProps } from '../../type';
import ProvinceCity from '../ProvinceCity';

export interface BaseAddressProps extends BaseHomeAddressProps {
    // 是否展示有美国邮寄地址的勾选框，仅非SSN四个中国开户流程使用，has_delivery_address字段。
    hasUSDeliveryAddress?: boolean;
    // 是否隐藏邮寄地址与居住地址不一致勾选框，默认展示，same_delivery_and_residence字段
    hideMailAddress?: boolean;
}

const BaseAddress: FC<BaseAddressProps> = props => {
    const { disabled, label = __('永久居住地址'), hasUSDeliveryAddress, hideMailAddress, prefix } = props;

    return (
        <>
            {label && <FormLabel>{label}</FormLabel>}
            <ProvinceCity disabled={disabled} nameOptions={{ prefix }} />
            <FormGroup
                className="mt-3 mb-2"
                name={`${prefix}_detail`}
                checker={(value: string) => {
                    if (disabled) {
                        return true;
                    }

                    if (!value) {
                        return __('请输入详细地址');
                    }

                    // 支持英文、数字、半角空格、特殊字符
                    if (!/^[a-zA-Z\d -/(),.#&:'"]+$/.test(value)) {
                        return __('请输入英文地址');
                    }

                    return true;
                }}>
                <FormControl disabled={disabled} placeholder={__('请输入详细地址')} />
            </FormGroup>
            {/* 用于非SSN四个中国开户流程，勾选后在后续单独一页收集美国邮寄地址 */}
            {hasUSDeliveryAddress && (
                <Checkbox disabled={disabled} name="has_delivery_address" label={__('I have a U.S. mailing address')} />
            )}
            {!hideMailAddress && <SameDeliveryAndResidence disabled={disabled} />}
        </>
    );
};

export default BaseAddress;
